/* src/app/system-utils/code-editor/code-editor.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.app-ace-editor {
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  box-shadow: var(--tem-shadow);
}
.editor-divider {
  margin: 0 0 5px 0;
}
.code-editor-container {
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: auto;
  position: relative;
}
.code-editor-container-code {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  font-size: 14px;
  width: 100%;
  padding: 10px;
}
.code-editor-container-console {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 100%;
  position: relative;
  font-family:
    "Cascadia Mono-SemiLight",
    Menlo,
    Monaco,
    Consolas,
    monospace;
  font-size: 14px;
  line-height: 19px;
  padding: 5px;
}
.code-editor-buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  padding-bottom: 5px;
}
.pre-container {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=code-editor.component.css.map */
